import React, { Component,  useEffect, useState}  from 'react';
import { Box, IconButton, TableCell } from '@material-ui/core';
import { CloseRounded } from '@material-ui/icons';
import { InputSelectMagasin } from '../../../../commonModules/interface/form-input-inline';

const ProductLineCell = (props) => {
    const [inputValue, setInputValue] = useState('');
    const [productListFormattedInitialList, setProductListFormattedInitialList] = useState([])  
    const [productListFormatted, setProductListFormatted] = useState([])  

    useEffect(() => {
        setProductListFormattedInitialList(props.options)
        setProductListFormatted(props.options)
    }, [props.options]);

    const handleInputChange = (event, newInputValue) => {
        console.log("Update handleInputChange")
        setInputValue(newInputValue);
    
        // Filtrer les options en fonction de la valeur d'entrée
        const filteredOptions = productListFormattedInitialList.filter(
          (option) => option.label.toLowerCase().indexOf(newInputValue.toLowerCase()) > -1
        );
    
        // Limiter les options filtrées à 100
        setProductListFormatted(filteredOptions.slice(0, 100));
        setInputValue(newInputValue);
      };

        return (
            <>
            <TableCell>
                <Box
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center"
                    }}
                >
                    {props.numberProd > 1 && !props.disabled &&
                    <IconButton 
                        onClick={props.handleDeleteProd}
                        // disabled={disabled} // TO DO  DELETE FROM RESA  ——> AVAILABLE
                    >
                        <CloseRounded color="error" />
                    </IconButton>
                    }
                    <Box p={1} style={{height:"100px", width: "100px"}}>
                        {props.PRODUCTS && props.value.value && props.PRODUCTS[props.value.value].photos &&
                            <img 
                                id={props.PRODUCTS[props.value.value].photos[0].filename} 
                                src={`/stocks/photos/${props.PRODUCTS[props.value.value].photos[0].filename}`} 
                                
                            />
                        }
                    </Box>
                    <InputSelectMagasin
                        options={productListFormatted.slice(0, 50)}
                        value={props.value || {value:"", label:""}}
                        label="Produit"
                        placeholder="Selectionner un Produit"
                        error={props.error}
                        onChange={props.onChange}
                        inputValue={inputValue}
                        onInputChange={handleInputChange}
                        helperText={props.helperText}
                        maxWidth
                        disabled={props.disabled}
                    />   
                </Box>
            </TableCell> 
            </>
        );
}

export default ProductLineCell;